<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent"></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent"></component>
      </div>
      <div slot="bottom_box_content">
        <component
          :is="curBottomComponent"
          :serviceType="2"
          :projectArray="projectArray"
        ></component>
      </div>
    </container>
  </div>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import deviceStoreModule from '@/store/modules/deviceManage'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    // 底部组件
    IndexTable: () => import('@/components/device/bottom/Index')
  },
  computed: {
    projectArray () {
      return this.$store.state.sys.projectArray
    }
  },
  created () {
    if (!this.$store.hasModule('deviceManage')) {
      this.$store.registerModule('deviceManage', deviceStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(false)
    this.setShowRightBlock(false)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setBottomComponent('IndexTable')
  },
  destroyed () {
    // this.setShowLeftBlock(false)
    // this.setShowMap(false)
    // this.setShowRightBlock(false)
    // this.setBottomHeight('300px')
    // this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
    this.$store.commit('reset_state')
    this.$store.unregisterModule('deviceManage')
  }
}
</script>
